"use client";

import React from "react";
import { ShieldCheck, Wifi, RefreshCw, Smartphone, ChevronRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EcosystemFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqItems = [{
    id: "item-1",
    question: "如何在 macOS 上顺利安装听力通？",
    answer: "非常简单！在下载页面选择 macOS 版本，下载完成后双击打开 .dmg 文件，将“听力通”图标拖拽到 Applications（应用程序）文件夹中即可。首次启动时如遇安全提示，请前往系统设置中允许运行即可。",
    icon: <ShieldCheck className="size-5 text-primary" />
  }, {
    id: "item-2",
    question: "学习进度可以在不同设备间同步吗？",
    answer: "当然可以。听力通支持多端云同步技术。无论你在 iPhone 上听了一半，还是在 Windows 电脑上标记了生词，只需登录同一个账号，所有学习记录、生词本和自定义设置都会实时同步到你的所有设备上。",
    icon: <Wifi className="size-5 text-primary" />
  }, {
    id: "item-3",
    question: "AI 自动识别断句不准确时该怎么办？",
    answer: "虽然我们的 AI 识别率已达到行业领先水平，但面对背景噪音极大的音频，你可以随时点击播放器下方的“编辑”按钮手动调整断句位置。你的每一次手动修正都会帮助 AI 模型学习，让下次识别更懂你。",
    icon: <RefreshCw className="size-5 text-primary" />
  }, {
    id: "item-4",
    question: "安卓手机版本有最低系统要求吗？",
    answer: "为了确保 AI 逐句拆解和音频渲染的流畅性，我们建议您的安卓设备系统版本在 Android 8.0 (Oreo) 及以上，并预留至少 500MB 的存储空间用于存放离线学习音频和缓存数据。",
    icon: <Smartphone className="size-5 text-primary" />
  }];
  return <section data-section-id="36110" id="常见安装问题" ref={ref} className={`bg-background text-foreground py-24 px-4 transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            常见<span className="text-primary">安装与使用</span>问题
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            遇到困难了吗？这里有关于安装、多端同步及 AI 功能的最常见解答。
          </p>
        </div>

        <div className="relative">
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-[80%] bg-primary/10 blur-3xl rounded-full pointer-events-none" />

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqItems.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="group border border-border bg-card/80 backdrop-blur-sm rounded-2xl px-4 transition-all duration-300 data-[state=open]:border-primary/40 data-[state=open]:bg-card data-[state=open]:shadow-xl hover:border-primary/20">
                <AccordionTrigger className="hover:no-underline py-6 [&[data-state=open]>div>svg]:text-primary">
                  <div className="flex items-center gap-4 text-left">
                    <div className="p-2 rounded-xl bg-muted group-data-[state=open]:text-primary group-data-[state=open]:bg-primary/10 transition-colors duration-300">
                      {item.icon}
                    </div>
                    <span className="text-base md:text-xl font-bold group-data-[state=open]:text-primary transition-colors">
                      {item.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-lg leading-relaxed pl-[3.25rem] pr-4 pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-6 text-lg">
            还有其他技术疑问？我们的支持团队随时待命。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button asChild variant="default" size="lg" className="rounded-full px-8 py-6 text-lg font-bold shadow-lg shadow-primary/20 hover:scale-105 transition-transform">
              <Link to="/FeedbackPage">
                联系技术支持
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="rounded-full px-8 py-6 text-lg font-bold border-2 border-border hover:bg-secondary/10 hover:border-secondary/50 transition-all">
              <Link to="/DownloadCenterPage">
                前往下载中心 <ChevronRight className="ml-1 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}